import {
   IconWrapper,
   Link,
   LinkSize,
   NotesIcon,
   Tooltip,
   TooltipLabel,
   TooltipPlacement,
} from '@dreryk/react-components';

import { translationKeys } from '../../translations';

import { AppointmentNoteManagementModalOpener } from './AppointmentNoteManagementModal.opener';

type AppointmentNoteCellProps = {
   readonly appointmentId: number;
   readonly note: string;
   readonly onNoteUpdated: VoidFunction;
};

export const AppointmentNoteCell = (props: AppointmentNoteCellProps): JSX.Element => {
   return (
      <AppointmentNoteManagementModalOpener
         appointmentId={props.appointmentId}
         appointmentNote={props.note}
         onAppointmentNoteUpdated={props.onNoteUpdated}
      >
         {({ openModal }) => (
            <Tooltip
               testId={'appointmentNote'}
               content={
                  <div>
                     <TooltipLabel label={translationKeys.noteManagement.tooltipLabel} />
                     {props.note}
                  </div>
               }
               placement={TooltipPlacement.TOP}
            >
               <Link
                  testId={'noteButton'}
                  size={LinkSize.BIG}
                  onClick={openModal}
                  icon={
                     <IconWrapper testId={'noteIcon'}>
                        <NotesIcon />
                     </IconWrapper>
                  }
               />
            </Tooltip>
         )}
      </AppointmentNoteManagementModalOpener>
   );
};
